import { createStore } from "vuex";

export default createStore({
  state: {
    taskId: "", // 任务ID
    center: [], // 定位 [116.397477, 39.908692]
    layers: "Satellite", // 地图图层
    viewMode: "2D", // 2D   3D
    pointMode: "gird", // 地图格式  点：dot 网格：gird  
    gasType: "o2", // 气体类型
    tracking: "A", // 追踪模式 （ F A M ）=>  Follow   Accord   Manual
    girdSize: 30, // 10~100
    aqiMode: "", // cn en
    heights: [0, 0], //高度 [最低，最高]，0默认无穷
    opacity: 80, //透明度
    collectType: 1,

    mobileTerminal: false,
    dialogVisible: false,
    deviceInfo: {
      device_sn: "",
    }, // 设备基本信息

    deviceStatusEvent: {
      deviceOnline: {},// 设备在线推送
      deviceOffline: {},// 设备离线推送
    },
    deviceNetworkEvent: {
      NetworkRecover: {},// 设备网络恢复
      NetworkDisconnect: {},// 设备网络掉线
    },
    deviceState: {
      mode: null, // 1 任务模式 2 调试模式
      // remote controller, dock
      gatewayInfo: {},
      // drone
      deviceInfo: {},
      dockInfo: {},
      currentSn: "",
      currentType: -1,

      osd_4g: {}, // 设备定位
      payload_osd: {}, // 设备状态
      ota_progress: {}, // 下载进度
      firmware_version: {}, // 版本号
    },
    markerInfo: {
      coverMap: {},
      pathMap: {},
    },
    workspace: {},
    // osdVisible: {
    //   // osd 显示设备相关信息
    //   sn: "",
    //   callsign: "",
    //   model: "",
    //   visible: false,
    //   gateway_sn: "",
    //   is_dock: false,
    //   payloads: null,
    // },

    gasFields: [], // 气体类型
    gasCollect: [], // 任务数据
    gasLogData: {}, // 历史数据
    gasCalibration: {}, // 调试数据
    gasReplayData: [], //重播数据
    // gasLog2: {},
    intervals: false, // 是否在录制
    interval2: false, // 允许录制
    infoWindow: false, // 窗口开关
    isReplay: false, // 重播开关
    isShow: false, // 录制任务页开关

    // 背景颜色
    BackgroundStatus: {
      Navigation: "top",
      TextColor: "#ffffff",
      HoverColor: "rgb(67, 74, 80)",
      BackgroundColor: "#545c64", // 545c64  3c444d
      ActiveTextColor: "#ffd04b",
    },
  },
  getters: {},
  mutations: {
    // setDevice(state, data) {
    //   state.deviceInfo = data;
    // },
    SET_DEVICE_4GOSD(state, info) {
      state.deviceState.osd_4g = info;
    },
    SET_DEVICE_PAYLOAD_OSD(state, info) {
      state.deviceState.payload_osd = info;
    },
    SET_DEVICE_OTA_PROGRESS(state, info) {
      state.deviceState.ota_progress = info;
    },
    SET_DEVICE_ONLINE(state, info) {
      state.deviceStatusEvent.deviceOffline = {};
      state.deviceStatusEvent.deviceOnline = info;
    },
    SET_DEVICE_OFFLINE(state, info) {
      state.deviceStatusEvent.deviceOnline = {};
      state.deviceStatusEvent.deviceOffline = info;
      // delete state.deviceState.gatewayInfo[info.sn];
      // delete state.deviceState.deviceInfo[info.sn];
      // delete state.deviceState.dockInfo[info.sn];
      // delete state.hmsInfo[info.sn];
      // // delete state.markerInfo.coverMap[info.sn]
      // // delete state.markerInfo.pathMap[info.sn]
    },
    // SET_OSD_VISIBLE_INFO(state, info) {
    //   state.osdVisible = info;
    // },
    SET_GAS_COLLECT_INFO(state, info) {
      state.gasCollect.push(info);
    },
    SET_GAS_CALIBRATION(state, info) {
      state.gasCalibration = info;
    },
    SET_GAS_FIELDS_INFO(state, info) {
      state.gasFields = info;
    },
  },
  actions: {},
  modules: {},
});
